export default __webpack_public_path__ + "static/media/363.7253b5c7.png";